var cov_201oyw2hov = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Card/Accordion.tsx",
      hash = "7a17d70126c9511636ec2038f8d4f6bbbf394d35",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Card/Accordion.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 20
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 81
        }
      },
      "2": {
        start: {
          line: 9,
          column: 60
        },
        end: {
          line: 9,
          column: 81
        }
      },
      "3": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 10
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 16
        }
      },
      "5": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "6": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 65
        }
      },
      "7": {
        start: {
          line: 27,
          column: 41
        },
        end: {
          line: 27,
          column: 65
        }
      },
      "8": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 28
        }
      },
      "9": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 51
        }
      },
      "10": {
        start: {
          line: 32,
          column: 38
        },
        end: {
          line: 32,
          column: 51
        }
      },
      "11": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 29
        }
      },
      "12": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 56
        }
      },
      "13": {
        start: {
          line: 34,
          column: 29
        },
        end: {
          line: 34,
          column: 56
        }
      },
      "14": {
        start: {
          line: 38,
          column: 19
        },
        end: {
          line: 38,
          column: 35
        }
      },
      "15": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "16": {
        start: {
          line: 40,
          column: 22
        },
        end: {
          line: 40,
          column: 77
        }
      },
      "17": {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 49,
          column: 7
        }
      },
      "18": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 46
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 20
          },
          end: {
            line: 8,
            column: 21
          }
        },
        loc: {
          start: {
            line: 8,
            column: 90
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 44
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 14
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 26
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        loc: {
          start: {
            line: 31,
            column: 33
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 37
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 39,
            column: 53
          },
          end: {
            line: 39,
            column: 54
          }
        },
        loc: {
          start: {
            line: 39,
            column: 67
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 81
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 81
          }
        }, {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 81
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 11
          }
        }, {
          start: {
            line: 9,
            column: 15
          },
          end: {
            line: 9,
            column: 26
          }
        }, {
          start: {
            line: 9,
            column: 30
          },
          end: {
            line: 9,
            column: 58
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 14
          },
          end: {
            line: 22,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 14
          },
          end: {
            line: 22,
            column: 26
          }
        }, {
          start: {
            line: 22,
            column: 30
          },
          end: {
            line: 22,
            column: 49
          }
        }],
        line: 22
      },
      "3": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 65
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 65
          }
        }],
        line: 27
      },
      "4": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 51
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 51
          }
        }],
        line: 32
      },
      "5": {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 56
          }
        }, {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 56
          }
        }],
        line: 34
      },
      "6": {
        loc: {
          start: {
            line: 45,
            column: 10
          },
          end: {
            line: 45,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 10
          },
          end: {
            line: 45,
            column: 35
          }
        }, {
          start: {
            line: 45,
            column: 39
          },
          end: {
            line: 45,
            column: 80
          }
        }],
        line: 45
      },
      "7": {
        loc: {
          start: {
            line: 46,
            column: 33
          },
          end: {
            line: 46,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 33
          },
          end: {
            line: 46,
            column: 40
          }
        }, {
          start: {
            line: 46,
            column: 44
          },
          end: {
            line: 46,
            column: 59
          }
        }],
        line: 46
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { Children, cloneElement } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { cardClass } from './styles';
import { isRTL } from '../config';
cov_201oyw2hov.s[0]++;

var getChildId = function getChildId(child, i) {
  cov_201oyw2hov.f[0]++;
  cov_201oyw2hov.s[1]++;

  if ((cov_201oyw2hov.b[1][0]++, child) && (cov_201oyw2hov.b[1][1]++, child.props) && (cov_201oyw2hov.b[1][2]++, child.props.id !== undefined)) {
    cov_201oyw2hov.b[0][0]++;
    cov_201oyw2hov.s[2]++;
    return child.props.id;
  } else {
    cov_201oyw2hov.b[0][1]++;
  }

  cov_201oyw2hov.s[3]++;
  return i;
};

var Accordion =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Accordion, _PureComponent);

  var _super = _createSuper2(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    cov_201oyw2hov.f[1]++;
    cov_201oyw2hov.s[4]++;
    _this = _super.call(this, props);
    cov_201oyw2hov.s[5]++;
    _this.state = {
      active: (cov_201oyw2hov.b[2][0]++, props.active) || (cov_201oyw2hov.b[2][1]++, props.defaultActive)
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: "getActive",
    value: function getActive() {
      cov_201oyw2hov.f[2]++;
      cov_201oyw2hov.s[6]++;

      if (this.props.active !== undefined) {
        cov_201oyw2hov.b[3][0]++;
        cov_201oyw2hov.s[7]++;
        return this.props.active;
      } else {
        cov_201oyw2hov.b[3][1]++;
      }

      cov_201oyw2hov.s[8]++;
      return this.state.active;
    }
  }, {
    key: "handleActive",
    value: function handleActive(active) {
      cov_201oyw2hov.f[3]++;
      cov_201oyw2hov.s[9]++;

      if (active === this.state.active) {
        cov_201oyw2hov.b[4][0]++;
        cov_201oyw2hov.s[10]++;
        active = null;
      } else {
        cov_201oyw2hov.b[4][1]++;
      }

      cov_201oyw2hov.s[11]++;
      this.setState({
        active: active
      });
      cov_201oyw2hov.s[12]++;

      if (this.props.onChange) {
        cov_201oyw2hov.b[5][0]++;
        cov_201oyw2hov.s[13]++;
        this.props.onChange(active);
      } else {
        cov_201oyw2hov.b[5][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_201oyw2hov.f[4]++;
      var active = (cov_201oyw2hov.s[14]++, this.getActive());
      cov_201oyw2hov.s[15]++;
      return Children.toArray(this.props.children).map(function (child, i) {
        cov_201oyw2hov.f[5]++;
        var childId = (cov_201oyw2hov.s[16]++, getChildId(child, i));
        var props = (cov_201oyw2hov.s[17]++, {
          collapsed: active !== childId,
          collapsible: true,
          className: classnames((cov_201oyw2hov.b[6][0]++, typeof child === 'object') && (cov_201oyw2hov.b[6][1]++, child.className), cardClass('accordion', (cov_201oyw2hov.b[7][0]++, isRTL()) && (cov_201oyw2hov.b[7][1]++, 'accordion-rtl'))),
          onCollapse: _this2.handleActive.bind(_this2, childId)
        });
        cov_201oyw2hov.s[18]++;
        return (
          /*#__PURE__*/
          cloneElement(child, props)
        );
      });
    }
  }]);

  return Accordion;
}(PureComponent);

Accordion.defaultProps = {
  defaultActive: 0
};
export default Accordion;